<template>
  <div class="ioc-transfer">
    <div class="content-top">
      <div class="content-top-left">
        <h2 class="title">{{ titles[0] }}</h2>
        <div class="content-main">
          <div>
            <el-input
              v-model="roleName"
              placeholder="请输入名称"
              clearable
              class="input-with-select"
            >
            </el-input>
          </div>
          <el-scrollbar class="scroll-bar">
            <div class="transfer-list-left transfer-list">
              <el-checkbox-group v-model="leftChecked" :disabled="disabled">
                <el-row
                  v-for="(item, index) in sourceList"
                  :key="index"
                  class="transfer"
                  :title="item[props.label]"
                >
                  <el-col :span="24">
                    <el-checkbox
                      style="
                        position: relative;
                        width: 100%;
                        height: 30px;
                        line-height: 30px;
                      "
                      :key="item[props.key]"
                      :label="item[props.key]"
                    >
                      {{ item[props.label] }}
                      <div style="position: absolute; top: 24%; right: 0">
                        <span
                          class="el-icon-delete"
                          v-if="item.planStepType === 1"
                          style="margin-right: 10px; width: 17px"
                          @click="deleteStep(item)"
                        ></span>
                      </div>
                    </el-checkbox>
                  </el-col>
                </el-row>
              </el-checkbox-group>
            </div>
          </el-scrollbar>
        </div>
      </div>

      <div class="content-top-middle">
        <div style="text-align: center; margin-bottom: 30px">
          <img
            src="@src/common/assets/images/arrows_left.png"
            @click="transferPerson('left')"
            style="cursor: pointer"
            alt=""
          />
        </div>
        <div style="text-align: center">
          <img
            src="@src/common/assets/images/arrows_right.png"
            @click="transferPerson('right')"
            alt=""
            style="cursor: pointer"
          />
        </div>
      </div>
      <div class="content-top-right" :class="type">
        <h2 class="title">{{ titles[1] }}</h2>
        <div class="content-main">
          <div>
            <el-input
              v-model="selectRoleName"
              clearable
              placeholder="请输入名称"
              class="input-with-select"
            >
            </el-input>
          </div>
          <el-scrollbar class="scroll-bar">
            <div class="transfer-list-right transfer-list">
              <el-checkbox-group v-model="rightChecked" :disabled="disabled">
                <el-row
                  v-for="(item, index) in targetList"
                  :key="item[props.key]"
                  class="transfer"
                  :title="item[props.label]"
                >
                  <el-col
                    style="
                      display: flex;
                      align-items: center;
                      position: relative;
                      width: 100%;
                      height: 30px;
                      line-height: 30px;
                    "
                  >
                    <el-checkbox
                      :key="item[props.key]"
                      :disabled="checkData(item)"
                      :label="item[props.key]"
                    >
                      {{ item[props.label] }}
                    </el-checkbox>
                    <div
                      v-if="!isOperation"
                      style="position: absolute; top: 24%; right: 0"
                    >
                      <img
                        v-if="index !== 0"
                        style="margin-right: 10px; width: 17px"
                        @click="moveUpClick(index)"
                        src="@/modules/reserve/image/move_up.svg"
                        :alt="$t('linkage.label.up')"
                      />
                      <img
                        type="text"
                        v-if="index !== targetList.length - 1"
                        @click="moveDownClick(index)"
                        src="@/modules/reserve/image/move_down.svg"
                        :alt="$t('linkage.label.down')"
                        style="width: 17px"
                      />
                    </div>
                    <div v-else></div>
                  </el-col>
                </el-row>
              </el-checkbox-group>
            </div>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "stepTransfer",
  props: {
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    filterable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    titles: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    props: {
      type: Object,
      default() {
        return {
          label: "label",
          key: "value",
          disabled: "disabled",
          children: "children",
        };
      },
    },
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isOperation: false,
      checked: [],
      leftChecked: [],
      rightChecked: [],
      leftTreeSelect: [],
      rightTreeSelect: [],
      roleName: "",
      selectRoleName: "",
      checkList: this.value,
    };
  },
  computed: {
    sourceList() {
      const ret = this.data.filter((item) => {
        return (
          item[this.props.label] &&
          item[this.props.label].indexOf(this.roleName.trim()) > -1 &&
          !this.value.includes(item[this.props.key])
        );
      });
      console.log(ret);
      console.log(this.data);
      return ret;
    },
    targetList() {
      const data = this.data.filter((item) => {
        return (
          item[this.props.label] &&
          item[this.props.label].indexOf(this.selectRoleName.trim()) > -1 &&
          this.value.includes(item[this.props.key])
        );
      });
      const ret = [];
      this.value.forEach((item) => {
        const index = data.findIndex((item1) => item1.value == item);
        if (index > -1) {
          ret.push(data[index]);
        }
      });
      console.log(ret);
      return ret;
    },
  },

  watch: {
    targetList() {
      this.rightChecked = [];
      this.dateChange();
    },
    sourceList() {
      this.leftChecked = [];
    },
  },

  methods: {
    checkData(item) {
      if (
        this.checkList.some((el) => {
          return item.value == el;
        })
      ) {
        return true;
      } else {
        return false;
      }
    },
    dateChange() {
      this.$emit("changeData", this.targetList);
    },
    // 向上移动
    moveUpClick(index) {
      if (this.disabled) {
        return;
      }

      if (index > 0 && !this.isOperation) {
        const keys = this.targetList.map((item) => item.value);
        let upDate = keys[index - 1];
        keys.splice(index - 1, 1);
        keys.splice(index, 0, upDate);
        this.$emit("update:value", keys);
      }
    },
    // 向下移动
    moveDownClick(index) {
      if (this.disabled) {
        return;
      }
      if (!this.isOperation) {
        const keys = this.targetList.map((item) => item.value);
        let downDate = keys[index + 1];
        keys.splice(index + 1, 1);
        keys.splice(index, 0, downDate);
        this.$emit("update:value", keys);
      }
    },

    checkChildren(list) {
      let keys = [];
      keys = list.map((item) => item[this.props.key]);
      if (list[this.props.children] && list[this.props.children].length) {
        let keys2 = this.checkChildren(list[this.props.children]);
        keys = keys.concat(keys2);
      }
      return keys;
    },

    // 移动人员
    transferPerson(type) {
      if (type === "left") {
        const remain = [];
        this.targetList.forEach((item) => {
          if (!this.rightChecked.includes(item.value)) {
            remain.push(item.value);
          }
        });
        this.$emit("update:value", remain);
      } else {
        this.$emit("update:value", [...this.value, ...this.leftChecked]);
      }
    },

    deleteStep(value) {
      this.$emit("deleteStep", value.planStepId);
    },
  },
};
</script>

<style lang="scss">
@import "~@src/common/assets/style/mixin";
.ioc-transfer {
  // margin-top: 24px;
  .content {
    &-top {
      // height: 380px;
      display: flex;
      align-content: space-around;
      &-left,
      &-right {
        overflow: hidden;
        width: 240px;
        height: 400px;
        @include set_theme_color(background-color, input-default-bg-color);
        h2 {
          @include set_theme_color(background-color, input-disabled-bg-color);
          margin-bottom: 0;
        }
        .account {
          line-height: 24px;
          padding: 0 10px;
          text-align: left;
        }
        .group-list {
          // height: 300px;
          // overflow-y: scroll;
          overflow: hidden;
        }
        .transfer-list {
          text-align: left;
          padding: 5px 10px 10px;
          overflow: hidden;
          .transfer {
            padding: 10px 0px;
            display: flex;
            flex-direction: row;
            align-items: center;
            .el-checkbox__label {
              vertical-align: middle;
              max-width: 180px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
      &-middle {
        width: 70px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-content: center;
        .to-left {
          margin: 100px 0px 10px 0px;
          background: transparent;
        }
        .to-right {
          margin-left: 2px;
          background: transparent;
        }
      }
      .date {
        flex: 1;
        width: 360px;
      }
    }
  }
  .scroll-bar {
    height: calc(100% - 85px);
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .content-main {
    height: calc(100% - 30px);
    padding: 10px;
    @include set_theme_color(background-color,page-default-bg);
  }
  .content-top-middle {
    width: 55px;
    display: flex;
    justify-content: center;
    align-content: center;
  }
  .dialog {
    .el-dialog__body {
      padding: 30px 0 0 0;
      background: rgb(53, 84, 134);
    }
  }
  .footer {
    text-align: right;
    padding: 20px 20px 20px 0;
    background: rgb(35, 57, 94);
  }
  .title {
    height: 30px;
    color: #fff;
    font-size: 14px;
    line-height: 30px;
    text-align: center;
    font-weight: normal;
  }
  .right-title {
    height: 48px;
    line-height: 48px;
  }
  .tree-list .personwidth {
    max-width: 220px;
    // overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .tree-list .el-tree .is-current > .el-tree-node__content,
  .tree-list .el-tree-node__content:hover {
    background-color: transparent;
  }
  .transfer-list .el-checkbox__input.is-checked + .el-checkbox__label {
    // color: #c9d5ec;
  }
  .expand {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-right: 2px;
    border: 1px solid #b3cbf1;
  }

  .el-date-editor--daterange.el-input,
  .el-date-editor--daterange.el-input__inner,
  .el-date-editor--datetimerange.el-input,
  .el-date-editor--datetimerange.el-input__inner {
    width: auto;
  }

  .content-top-left {
    position: relative;
  }
  .content-top-left .el-icon-plus {
    position: absolute;
    top: 8px;
    right: 14px;
    color: #fff;
  }
  .step-input {
    margin: 8px 0 5px 15px;
  }
  .step-input .input {
    border: 1px solid rgb(88, 157, 246);
    height: 27px;
  }
  .step-input .input {
    width: 160px;
    color: #fff;
  }
  .step-input span {
    font-size: 16px;
    color: rgb(88, 157, 246);
  }
  .step-input .el-icon-check {
    font-size: 16px;
    margin: 0 6px;
  }
  .select-role {
    text-align: center;
    @include set_theme_color(color, font-default-color);
  }

  .date-range-column {
    display: flex;
    flex-direction: row;
  }

  .el-checkbox {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .el-checkbox__label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .el-date-editor .el-range-separator {
    width: 25px;
  }
}
</style>
